import React from 'react';
import styled, { css } from 'styled-components';
import { MagnifyingGlassSvg } from '../../../icons';

export const SearchBar = (props) => {
  return (
    <Wrapper>
      <Input autoFocus value={props.value} onChange={props.onChange} placeholder="Search" />
      <div className="absolute right-3">
        <MagnifyingGlassSvg color={window?.settings?.secondary_color ?? '#04333b'} />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  position: relative;
`;

const Input = styled.input`
  ${({ theme }) => css`
    outline: none;
    height: 100%;
    width: 100%;

    padding-left: 12px;
    padding-right: 12px;
    
    background-color: #F7F7F7;
    border: 1px solid #E3E3E3;

    &:focus{
      background-color: #FFFFFF;
      border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
    }
  `}
`;